import { render, staticRenderFns } from "./BankAccountHeader.vue?vue&type=template&id=43e3ae22&scoped=true&"
import script from "./BankAccountHeader.vue?vue&type=script&lang=js&"
export * from "./BankAccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountHeader.vue?vue&type=style&index=0&id=43e3ae22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e3ae22",
  null
  
)

export default component.exports